import { Button } from "@/components/ui/button";
import { Link } from "wouter";
import { Sparkles } from "lucide-react";
import type { SuggestionView } from "@/hooks/useSuggestions";

/**
 * One detected introduction, with Confirm and Not this. Never applies itself:
 * a person decides.
 */
export function SuggestionRow({ s, onAccept, onDismiss, pending, showCompany = true }: {
  s: SuggestionView; onAccept: () => void; onDismiss: () => void; pending?: boolean; showCompany?: boolean;
}) {
  const when = s.occurredAt ? new Date(s.occurredAt).toLocaleDateString("en-US", { month: "short", day: "numeric" }) : null;
  const who = (
    <Link href={s.referrerKind === "coi" ? `/coi/${s.contactId}` : `/contacts/${s.contactId}`} className="font-medium hover:underline">
      {s.contactName}
    </Link>
  );
  const company = showCompany ? (
    <Link href={s.companyCategory === "Client" ? `/clients/${s.companyId}` : `/prospects/${s.companyId}`} className="font-medium hover:underline">
      {s.companyName}
    </Link>
  ) : <span className="font-medium">this company</span>;
  return (
    <div className="flex items-center justify-between gap-3 rounded-md border border-amber-300/60 bg-amber-50/60 dark:bg-amber-950/20 px-3 py-2 text-sm">
      <div className="flex items-start gap-2 min-w-0">
        <Sparkles className="w-3.5 h-3.5 mt-0.5 text-amber-600 shrink-0" />
        <div className="min-w-0">
          {s.direction === "in"
            ? <span>Looks like {who}{s.contactFirmName ? <span className="text-muted-foreground"> ({s.contactFirmName})</span> : null} introduced {company}</span>
            : <span>Looks like you sent {company} to {who}</span>}
          {(when || s.subject) && <div className="text-xs text-muted-foreground truncate">{[when, s.subject].filter(Boolean).join(" · ")}</div>}
        </div>
      </div>
      <div className="flex gap-1 shrink-0">
        <Button size="sm" className="h-7 text-xs" onClick={onAccept} disabled={pending}>Confirm</Button>
        <Button size="sm" variant="ghost" className="h-7 text-xs" onClick={onDismiss} disabled={pending}>Not this</Button>
      </div>
    </div>
  );
}
